import axios from "axios";
import { syncSessionCooling } from "../redux/sessionCoolingSlice";
import {
  isSessionCoolingResponse,
  normalizeSessionCooling,
} from "../utils/sessionCoolingHelpers";

let wired = false;

function applyCoolingFromPayload(store, payload) {
  if (!payload?.sessionCooling) return;
  store.dispatch(syncSessionCooling(payload.sessionCooling));
}

export function wireAxiosSessionCoolingListeners(store) {
  if (wired) return;
  wired = true;

  axios.interceptors.response.use(
    (response) => {
      applyCoolingFromPayload(store, response.data);
      return response;
    },
    (error) => {
      const res = error.response;
      const data = res?.data;
      if (isSessionCoolingResponse(res?.status, data)) {
        store.dispatch(syncSessionCooling(normalizeSessionCooling(data.sessionCooling || data)));
      }
      return Promise.reject(error);
    }
  );
}
